import { ChangeDetectionStrategy, Component, input, output, signal } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-file-drop-zone',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './file-drop-zone.component.html',
  styleUrl: './file-drop-zone.component.scss',
  imports: [MatIconModule],
})
export class FileDropZoneComponent {
  readonly hint = input('');
  readonly accept = input('');
  readonly multiple = input(false);

  readonly filesAdded = output<File[]>();

  protected readonly dragOver = signal(false);

  onInputChange(event: Event): void {
    const input = event.target as HTMLInputElement;
    this.emit(input.files);
    input.value = '';
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    this.dragOver.set(true);
  }

  onDragLeave(event: DragEvent): void {
    event.preventDefault();
    this.dragOver.set(false);
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    this.dragOver.set(false);
    this.emit(event.dataTransfer?.files ?? null);
  }

  private emit(files: FileList | null): void {
    const list = Array.from(files ?? []);
    if (list.length) {
      this.filesAdded.emit(list);
    }
  }
}
